import { render, staticRenderFns } from "./actionFieldComboTabList.vue?vue&type=template&id=83e366b2"
import script from "./actionFieldComboTabList.vue?vue&type=script&lang=js"
export * from "./actionFieldComboTabList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports